// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ra-0";
export var discountCodeInput = "_ra-1";